import React__default from 'react';
import Grid from '../../../Grid.js';
import Pagination from '../../../Pagination.js';
import { SET_NEXT_PAGE, SET_PREV_PAGE, SET_FIRST_PAGE, SET_LAST_PAGE, SET_CURRENT_PAGE } from './utils/constants.js';
import { usePagination } from './utils/hooks.js';

var PaginationNavigation = function PaginationNavigation(_ref) {
  var dataTestId = _ref.dataTestId;
  var _usePagination = usePagination(),
    dispatch = _usePagination.dispatch,
    _usePagination$state = _usePagination.state,
    currentPage = _usePagination$state.currentPage,
    hidePaginationNavigation = _usePagination$state.hidePaginationNavigation,
    isServer = _usePagination$state.isServer,
    isClient = _usePagination$state.isClient,
    _onRequestFirst = _usePagination$state.onRequestFirst,
    _onRequestLast = _usePagination$state.onRequestLast,
    _onRequestNext = _usePagination$state.onRequestNext,
    _onRequestPage = _usePagination$state.onRequestPage,
    _onRequestPrev = _usePagination$state.onRequestPrev,
    pageSize = _usePagination$state.pageSize,
    totalPages = _usePagination$state.totalPages;
  return /*#__PURE__*/React__default.createElement(Grid.Item, {
    className: "C-Pagination__childComponent",
    xs: 4
  }, hidePaginationNavigation !== true && /*#__PURE__*/React__default.createElement(Grid.Container, {
    className: "C-Pagination__paginationNavigation hc-mb-normal",
    justify: "center"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Pagination, {
    currentPage: currentPage,
    "data-testid": dataTestId ? "".concat(dataTestId) : null,
    onRequestNext: function onRequestNext(event) {
      if (isClient) {
        dispatch({
          type: SET_NEXT_PAGE
        });
      }
      if (typeof _onRequestNext === 'function' && isServer) {
        _onRequestNext({
          currentPage: currentPage,
          event: event,
          pageSize: pageSize,
          totalPages: totalPages
        });
      }
    },
    onRequestPrev: function onRequestPrev(event) {
      if (isClient) {
        dispatch({
          type: SET_PREV_PAGE
        });
      }
      if (typeof _onRequestPrev === 'function' && isServer) {
        _onRequestPrev({
          currentPage: currentPage,
          event: event,
          pageSize: pageSize,
          totalPages: totalPages
        });
      }
    },
    onRequestFirst: function onRequestFirst(event) {
      if (isClient) {
        dispatch({
          type: SET_FIRST_PAGE
        });
      }
      if (typeof _onRequestFirst === 'function' && isServer) {
        _onRequestFirst({
          currentPage: currentPage,
          event: event,
          pageSize: pageSize,
          totalPages: totalPages
        });
      }
    },
    onRequestLast: function onRequestLast(event) {
      if (isClient) {
        dispatch({
          type: SET_LAST_PAGE
        });
      }
      if (typeof _onRequestLast === 'function' && isServer) {
        _onRequestLast({
          currentPage: currentPage,
          event: event,
          pageSize: pageSize,
          totalPages: totalPages
        });
      }
    },
    onRequestPage: function onRequestPage(event, newPage) {
      if (isClient) {
        dispatch({
          payload: newPage,
          type: SET_CURRENT_PAGE
        });
      }
      if (typeof _onRequestPage === 'function' && isServer) {
        _onRequestPage({
          currentPage: currentPage,
          event: event,
          newPage: newPage,
          pageSize: pageSize,
          totalPages: totalPages
        });
      }
    },
    pageSelector: true,
    totalPages: totalPages
  }))));
};

export { PaginationNavigation as default };
